import React from 'react'
import { IssuesCardWrapper } from './IssuesCard.style'
import { getDate } from 'helper/utils';
import addIcon from "assets/images/addIcon.svg";
import removeIcon from "assets/images/removeIcon.svg";


export default function IssuesCard({item,buttonType,handleButtonClick,tag1,onClickOnCard}) {
 
  return (
    <IssuesCardWrapper>
        <div className={item.status =="reverted"?"revertedCard":'issueCard'} >
            {
              tag1 &&  <div className={tag1.toLowerCase()=="iq"?'tag1-alt':'tag1'}><p>{tag1}</p></div>
            }
            <p className='issueHeading'  onClick={onClickOnCard}>Issue-{item.id}  {item.total_questions && <span className='totalQ'>({item.total_questions})</span>} </p>
           
            <p className='liveQName'>Qname : {item.live_q_name}</p>
            <div className='dateAndB'>
                <p className='date'>{getDate(item.createdAt)}</p>
                {
                  buttonType===1?<img onClick={()=>handleButtonClick(item.live_q_name)} src={addIcon} width={20} alt="" />:
                  buttonType==2 && item.status == "pending"?<img onClick={()=>handleButtonClick(item.live_q_name)} src={removeIcon} width={20} alt="" />:""
                }
            </div>
            
        </div>
    </IssuesCardWrapper>
  )
}
